export const SANDBOX_PROJECT = 'Sandbox';
